export class ForgotPasswordModel {
    password: string;
    reply: string;
    token: string;
}